import React from 'react';

interface TooltipPayloadItem {
  name?: string;
  value?: number | string;
  color?: string;
  dataKey?: string;
  payload?: { fill?: string };
}

interface Props {
  active?: boolean;
  payload?: TooltipPayloadItem[];
  label?: string | number;
  valueLabel?: string;
  valueFormatter?: (v: number | string) => string;
}

const ChartTooltip: React.FC<Props> = ({
  active,
  payload,
  label,
  valueLabel,
  valueFormatter,
}) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div
      style={{
        background: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 10,
        padding: '10px 12px',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        fontSize: 12,
        color: '#0f172a',
        minWidth: 140,
      }}
    >
      {label !== undefined && (
        <div
          style={{
            fontWeight: 700,
            marginBottom: 6,
            letterSpacing: '-0.01em',
          }}
        >
          {label}
        </div>
      )}
      {payload.map(entry => {
        const dot = entry.color || entry.payload?.fill || '#006633';
        const formatted =
          typeof entry.value === 'number' && valueFormatter
            ? valueFormatter(entry.value)
            : entry.value;
        return (
          <div
            key={`${entry.name}-${entry.dataKey}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              color: '#475569',
              fontWeight: 500,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 10,
                height: 10,
                borderRadius: 3,
                background: dot,
              }}
            />
            <span style={{ flex: 1 }}>{valueLabel || entry.name}</span>
            <span style={{ fontWeight: 700, color: '#0f172a' }}>
              {formatted}
            </span>
          </div>
        );
      })}
    </div>
  );
};

ChartTooltip.defaultProps = {
  active: false,
  payload: undefined,
  label: undefined,
  valueLabel: undefined,
  valueFormatter: undefined,
};

export default ChartTooltip;
